import * as React from 'react';
import { OptionIcon } from 'ui/common/select/option/option-icon';
import { SelectItem } from '../types';
import { insertOptionalWordbreaks } from 'app/infrastructure/platform';
import { isDefinedIncludingZero } from 'app/infrastructure/data/number';
import { OptionColor } from 'ui/common/select/option/option-color';

import type { JSX } from "react";

export interface OptionDescriptionProps {
  item: SelectItem;
  showIcons: boolean;
  selectSymbol?: JSX.Element;
  hideSelection?: boolean;
  showBackgroundColour?: boolean;
}

export class OptionDescription extends React.Component<OptionDescriptionProps, any> {
  public render() {
    const {	item, showIcons, selectSymbol, hideSelection, showBackgroundColour } = this.props;
    const { value, description, icon } = item;

    const classNames = 'form-check-label' +
      (hideSelection ? ' no-select' : '') + 
      (!selectSymbol && !showBackgroundColour && !(showIcons && icon) ? ' no-icon' : '');
    
    return (
      <label htmlFor={`select-option-${value}-${description}`} className={classNames}>
        {selectSymbol}
        {showBackgroundColour && isDefinedIncludingZero(item.backgroundColor) && <OptionColor color={item.backgroundColor} />}
        <span>
          {showIcons && !!icon && <OptionIcon iconUrl={icon} />}
          {insertOptionalWordbreaks(description)}
        </span>
      </label>
    );
  }
}
